import WaveSurfer from 'wavesurfer.js';

export default () => ({
    playing: false,
    hide: false,
    wavesurfer: null,
    activated: false,

    init() {
        this.$watch('playing', value => {
            if (this.wavesurfer) {
                if (value) {
                    this.wavesurfer.play();
                } else {
                    this.wavesurfer.pause();
                }
            }
        });

        this.$watch('hide', value => {
            if (value) {
                this.$el.classList.add('opacity-0', 'pointer-events-none');
                setTimeout(() => {
                    this.$el.remove();
                    if (this.wavesurfer) {
                        this.wavesurfer.destroy(); // Clean up wavesurfer instance
                    }
                    this.activated = false;
                }, 500);
            }
        });
    },

    initializeWavesurfer() {
        if (this.wavesurfer) return;

        if (!this.$refs.audio) {
            console.error('Audio element not found for AudioPlayer.');
            return;
        }

        this.wavesurfer = WaveSurfer.create({
            container: this.$refs.waveform,
            waveColor: '#7B4D35',
            progressColor: 'rgba(123, 77, 53, 0.5)',
            media: this.$refs.audio,
            interact: true,
            hideScrollbar: true,
            height: 33,
            barWidth: 2,
            barGap: 2,
            barRadius: 2,
        });

        this.wavesurfer.on('play', () => {
            this.playing = true;
        });

        this.wavesurfer.on('pause', () => {
            this.playing = false;
        });

        this.wavesurfer.on('finish', () => {
            this.playing = false;
        });
    },

    togglePlay() {
        if (!this.activated) {
            this.activated = true;
        }
        this.initializeWavesurfer();
        if (this.wavesurfer) {
            this.wavesurfer.playPause();
        }
    }
});
